import React from "react";
import "./Chats.css";
import Chat from "./Chat";

function Chats() {
  return (
    <div className="chats">
      <Chat
        name="Mark"
        message="Yo pickup line or simple hy"
        timestamp="40 seconds ago"
        profilePic="https://scontent.fixr3-1.fna.fbcdn.net/v/t1.6435-9/186561368_2923024637910783_504528976115361762_n.jpg?_nc_cat=100&ccb=1-3&_nc_sid=09cbfe&_nc_ohc=1pIbtmuN_cAAX-4SwUe&_nc_ht=scontent.fixr3-1.fna&oh=12e3c143ccfcbb05745505475b713f43&oe=6127E88D"
      />

      <Chat
        name="antonio"
        message="Yo pickckhsddkbcup line or simple hy"
        timestamp="50 seconds ago"
        profilePic="https://scontent.fixr3-1.fna.fbcdn.net/v/t1.6435-9/186561368_2923024637910783_504528976115361762_n.jpg?_nc_cat=100&ccb=1-3&_nc_sid=09cbfe&_nc_ohc=1pIbtmuN_cAAX-4SwUe&_nc_ht=scontent.fixr3-1.fna&oh=12e3c143ccfcbb05745505475b713f43&oe=6127E88D"
      />
      <Chat
        name="james"
        message="Yo prgfwesrfvgwfbvwsrickup line or simple hy"
        timestamp="10 seconds ago"
        profilePic="https://scontent.fixr3-1.fna.fbcdn.net/v/t1.6435-9/186561368_2923024637910783_504528976115361762_n.jpg?_nc_cat=100&ccb=1-3&_nc_sid=09cbfe&_nc_ohc=1pIbtmuN_cAAX-4SwUe&_nc_ht=scontent.fixr3-1.fna&oh=12e3c143ccfcbb05745505475b713f43&oe=6127E88D"
      />
      <Chat
        name="addi"
        message="Yo pickup avwfrvwfervline or simple hy"
        timestamp="45 seconds ago"
        profilePic="https://scontent.fixr3-1.fna.fbcdn.net/v/t1.6435-9/186561368_2923024637910783_504528976115361762_n.jpg?_nc_cat=100&ccb=1-3&_nc_sid=09cbfe&_nc_ohc=1pIbtmuN_cAAX-4SwUe&_nc_ht=scontent.fixr3-1.fna&oh=12e3c143ccfcbb05745505475b713f43&oe=6127E88D"
      />
    </div>
  );
}

export default Chats;
